import { baseUrl } from "@/utils/baseUrl";
import { setStorage, getStorage } from "@/utils/wxuser";
import gcTrack from "@/utils/gcTrack";
import { miniProgram } from "@/utils/miniProgram";
import { base64 } from "@/utils/base";
import CryptoJS from 'crypto-js';

var config = getStorage('config');
export const preventScroll = function () {
  document.body.style.overflow = 'hidden'
  document.body.style.height = '100%'
}

export const restoreScroll = function () {
  document.body.style.overflow = ''
  document.body.style.height = ''
}

export const isWeChat = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};
export const scriptLoad = (url, callback) => {
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.charset = "utf-8";
  script.onload = script.onreadystatechange = function () {
    if (
      !this.readyState ||
      this.readyState === "loaded" ||
      this.readyState === "complete"
    ) {
      callback && callback();
      script.onload = script.onreadystatechange = null;
    }
  };
  script.src = url;
  head.appendChild(script);
};
export const checkUrl = (to) => {
  let url = window.location.href;
  if (url.indexOf("tfbank") > -1 && url.indexOf("token") < url.indexOf(to.name)) {
    sessionStorage.setItem('debugMode', "T");
    let ulrObj = new URL(url);
    window.location.href = ulrObj.origin + ulrObj.pathname + ulrObj.hash + ulrObj.search;
    return false;
  }
  if (url.indexOf(`${baseUrl}`) < 0) {
    window.location.href = `${window.location.origin}${baseUrl}#${to.fullPath}`;
  }
}
export const isReservationMan = () => {
  var isReservationMan = false;
  let user = getStorage('user');
  if (user && user.memberId) {
    user.memberRoleLDtoList.forEach((n, i) => {
      if (n.memberRole == "2") {
        isReservationMan = true;
      }
    });
  }
  return isReservationMan;
}
export const getQueryStringFromUrl = function (fromUrl, name) {
  try {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var w = fromUrl.split("?");
    var url = w[w.length - 1]
    var r = url.match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return "";
  } catch (e) {
    return "";
  }
}
export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2]; return '';
}
export function performance() {
  let timing = window.performance.timing,
    start = timing.navigationStart,
    dnsTime = 0,
    tcpTime = 0,
    firstPaintTime = 0,
    domRenderTime = 0,
    loadTime = 0;
  dnsTime = timing.domainLookupEnd - timing.domainLookupStart;
  tcpTime = timing.connectEnd - timing.connectStart;
  firstPaintTime = timing.responseStart - start;
  domRenderTime = timing.domContentLoadedEventEnd - start;
  loadTime = timing.loadEventEnd - start;
  window.performance.getEntriesByType('paint')
  console.log('DNS解析时间:', dnsTime, 'TCP建立时间:', tcpTime, '首屏时间:', firstPaintTime, 'dom渲染完成时间:', domRenderTime, '页面onload时间:', loadTime);
}
export const initGcTrack = () => {
  let wxuser = getStorage('wxuser');
  let user = getStorage('user');
  let login_id = "";

  if (user && user.memberId && user.mobile) {
    login_id = user.mobile;
  } else if (wxuser && wxuser.openid) {
    login_id = wxuser.openid;
  }
  if (wxuser && wxuser.openid) {
    let platform_name = "公众号H5";
    gcTrack.identify(wxuser.openid)
    if (user && user.memberId && user.mobile) {
      gcTrack.login(login_id)
    }
    gcTrack.init({
      server_url: 'https://sc.wx.gcihotel.net/sa?project=production',
      is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      use_client_time: true,
      send_type: 'beacon',
      heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default'
      }
    });
    gcTrack.quick('autoTrack');
    let is_login = false;
    let vip_level = "";
    let share_id = "";
    if (user && user.memberId) {
      is_login = true;
      vip_level = user.cardLevel
    }

    let gcTrackOption = Object.assign({
      hotel_group_code: config.hotelGroupCode,
      appid: config.appid,
      hotel_code: config.hotelCode

    }, {
      $project: "production",
      is_login,
      vip_level,
      share_id,
      platform_name
    })
    gcTrack.registerPage(gcTrackOption);
  }
};
export const isWeCom = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.match(/wxwork/i) == 'wxwork') {
    return true;
  } else {
    return false;
  }
};
export const setCookie = (name, value, second) => {
  var date = new Date();
  if (!second) {
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
  }
  var domain = `domain=${getRootDomain()}`;
  var expires = "expires=" + date.toGMTString();
  document.cookie = `${name}=${value};expires=${expires};${domain}`
}
export const getCookie = (name) => {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(name + '='); //获取字符串的起点
    if (c_start != -1) {
      c_start = c_start + name.length + 1; //获取值的起点
      var c_end = document.cookie.indexOf(';', c_start); //获取结尾处
      if (c_end == -1) c_end = document.cookie.length; //如果是最后一个，结尾就是cookie字符串的结尾
      return decodeURI(document.cookie.substring(c_start, c_end)); //截取字符串返回
    }
  }
  return '';
}
export const getRootDomain =() => {
  var domain = window.location.hostname;

  var parts = domain.split(".");
  console.log(parts)
  if (parts.length > 3) {
    domain = parts.slice(parts.length - 3).join(".");
  }
  return domain;
}
export function yxyPay(obj) {
  let newObj = obj;
  if(newObj.prepay_id){
    newObj.prepay_id = newObj.prepay_id
  }
  if(newObj.successPath){
    let successPath = removeParamsFromHash(newObj.successPath,['token','appId'])
    newObj.successPath = successPath
  }
  if(newObj.failPath){
    let failPath = removeParamsFromHash(newObj.failPath,['token','appId'])
    newObj.failPath = failPath
  }
  let param = encodeURIComponent(JSON.stringify(newObj))
  console.log(`支付参数param:${param}`)
  miniProgram.navigateTo({
    url:`/otherSubpkg/pages/h5Pay/greenPay2?param=${param}`
  })
}

export function removeParamsFromHash(url, paramsToRemove = []) {
  const [baseUrl, hash] = url.split("#");
  if (!hash) return url;

  const [path, queryString = ""] = hash.split("?");
  const searchParams = new URLSearchParams(queryString);

  // 循环删除多个参数
  for (const param of paramsToRemove) {
    searchParams.delete(param);
  }

  const newHash = searchParams.toString()
    ? `${path}?${searchParams}`
    : path;

  return `${baseUrl}#${newHash}`;
}

export function yxyMap(obj) {
  let param = encodeURIComponent(base64.encode(JSON.stringify(obj)))
  console.log(`导航参数param:${param}`)
  miniProgram.navigateTo({
    url:`/otherSubpkg/pages/h5Pay/openMap?param=${param}`
  })
}

export const hexToRgba =(hex, opacity) =>{
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return `rgba(${parseInt(result[1], 16)},${parseInt(
    result[2],
    16
  )},${parseInt(result[3], 16)}, ${opacity})`;
}

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 */
export function aesEncrypt(word, keyWord = "jkl;POIU1234++==") {
  var key = CryptoJS.enc.Utf8.parse(keyWord);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return encrypted.toString();
}

/**
 * @word 要解密的密文
 * @keyWord String  加密时使用的关键字 解密不出来就原值
 */
export function aesDecrypt(word, keyWord = "jkl;POIU1234++==") {
  try{
    var key = CryptoJS.enc.Utf8.parse(keyWord);
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()||word;
  }catch(e){
    return word
  }
  
} 



// WEBPACK FOOTER //
// ./src/utils/utils.js